import React from 'react';
import { Link2, Clock, X, Check, FileText, Eye } from 'lucide-react';
import { Button } from './ui/Button';

interface Props {
  link: string;
  expiry: string | null;
  copied: boolean;
  onCopy: () => void;
  onDismiss: () => void;
}

export const TxnLinkCard: React.FC<Props> = ({ link, expiry, copied, onCopy, onDismiss }) => (
  <div className="rounded-xl border border-indigo-200 bg-gradient-to-r from-indigo-50 to-blue-50 p-4 shadow-sm mb-4">
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <div className="bg-indigo-100 p-1.5 rounded-full">
          <Link2 size={14} className="text-indigo-600" />
        </div>
        <h4 className="text-sm font-semibold text-gray-900">Transaction Link</h4>
        {expiry && (
          <span className="flex items-center gap-1 text-xs text-gray-600 bg-white border border-gray-200 rounded-full px-2 py-0.5">
            <Clock size={11} /> Expires in {expiry}
          </span>
        )}
      </div>
      <button onClick={onDismiss} className="text-gray-400 hover:text-gray-600" aria-label="Dismiss link">
        <X size={16} />
      </button>
    </div>
    <div className="flex items-center gap-2">
      <input
        readOnly
        value={link}
        onFocus={(e) => e.currentTarget.select()}
        className="flex-1 min-w-0 truncate bg-white border border-indigo-200 rounded-lg px-3 py-2 text-sm font-mono text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <Button
        size="sm"
        onClick={onCopy}
        className={`flex items-center gap-1 text-white ${copied ? 'bg-green-600 hover:bg-green-700' : 'bg-indigo-600 hover:bg-indigo-700'}`}
      >
        {copied ? <Check size={14} /> : <FileText size={14} />}
        {copied ? 'Copied' : 'Copy'}
      </Button>
      <Button size="sm" variant="outline" onClick={() => window.open(link, '_blank')} className="flex items-center gap-1">
        <Eye size={14} /> Open
      </Button>
    </div>
  </div>
);